import isNil from 'lodash/isNil'
import { getLocalStorage, setLocalStorage } from '../../services/local-preferences/index'
import { isSeriesVideo } from '../../services/video/utils'

const LS_KEY_PREFIX_AUDIO = 'LS_AUDIO_'
const LS_KEY_PREFIX_SUBTITLE = 'LS_SUBTITLE_'

function getMediaId (video) {
  return isSeriesVideo(video)
    ? video.getIn(['data', 'seriesId'])
    : video.getIn(['data', 'id'])
}

function getLocalStorageKey (video, key, auth = null) {
  const idKey = getMediaId(video)
  const uid = auth.get('uid', null)
  return `${uid}_${key}_${idKey}`
}

function getSavedPreference (prefixKey, video, auth) {
  const key = getLocalStorageKey(video, prefixKey, auth)
  return getLocalStorage(key)
}

function savePreferences (key, value, video, auth) {
  const AUTOCAPTIONS = 'auto'
  const valueText = value.lang === 'Auto' ? AUTOCAPTIONS : value
  const uid = auth.get('uid')
  setLocalStorage(getLocalStorageKey(video, key, auth), valueText, uid, auth)
}

export function saveAudioPreferences (value, video, auth) {
  savePreferences(LS_KEY_PREFIX_AUDIO, { lang: value }, video, auth)
}

export function getSavedAudioLanguage (video, auth) {
  return getSavedPreference(LS_KEY_PREFIX_AUDIO, video, auth)
}

export function getActiveAudioLanguageTrack (video, auth, userLanguages, media) {
  const savedPreference = getSavedAudioLanguage(video, auth)

  const appLang = userLanguages.get(0, null)
  const defaultMediaLang = media.getIn(['data', 'mediaLang'], null)

  if (!isNil(savedPreference)) {
    return savedPreference.lang
  }

  const isMediaHaveAppLang = media.find((item) => item === appLang)
  return isMediaHaveAppLang ? appLang : defaultMediaLang
}

export function saveSubtitlesPreferences (value, video, auth) {
  savePreferences(LS_KEY_PREFIX_SUBTITLE, { lang: value }, video, auth)
}

export function getSubtitlesPreferences (video, auth) {
  const savedPreference = getSavedPreference(LS_KEY_PREFIX_SUBTITLE, video, auth)
  return savedPreference ? savedPreference.lang : undefined
}
